/* eslint-disable no-param-reassign */
function changeCheckState(elements, checkState) {
  return elements.map(element => {
    if (!element.disabled) {
      element.checked = checkState;
    }
    return element;
  });
}
function toggleMainElementProperties(mainElement, totalCheckElements, totalCheckElementsActives) {
  if (totalCheckElements === totalCheckElementsActives) {
    mainElement.checked = true;
    mainElement.indeterminate = false;
  }
  else if (totalCheckElementsActives === 0) {
    mainElement.checked = false;
    mainElement.indeterminate = false;
  }
  else {
    mainElement.checked = false;
    mainElement.indeterminate = true;
  }
}
function onInputClick(event) {
  if (this.disabled)
    return;
  if (this.main)
    this.indeterminate = false;
  this.checked = event.target.checked;
}

export { changeCheckState as c, onInputClick as o, toggleMainElementProperties as t };
